export default {
	title: "Payment Methods",
	tips: "Dear user, please fill in your ERC20/TRC20 address. Please do not enter your bank account detail and password",
	form: {
		TransactionPassword: "Transaction Password",
		Address: "Wallet Address"
	},
	label: ["Bank Name", "Branch Code", "Branch Name", "Deposit Type", "Account Number", "Bank Account Holder"],
	tabs: ["Bank Card", "Network"],
	delete: "Delete",
	default: "Default",
	create: "Create",
	verifying: "verifying...",
	type: "Withdrawal Type",
	VerifyWalletAddress: "Verify Wallet Address",
	defaultAccount: "Default Withdrawal Account",
	deleteMsg: "Are you sure you want to delete?"
};
